module.exports = __webpack_public_path__ + "static/media/DSC00471-9_Small.bdde60cf.jpg";